/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetSiteDocumentsResponseData,
  GetSiteDocumentsResponseDataFromJSON,
  GetSiteDocumentsResponseDataFromJSONTyped,
  GetSiteDocumentsResponseDataToJSON
} from './GetSiteDocumentsResponseData'

/**
 *
 * @export
 * @interface GetSiteDocumentsResponse
 */
export interface GetSiteDocumentsResponse {
  /**
   *
   * @type {number}
   * @memberof GetSiteDocumentsResponse
   */
  status?: number
  /**
   *
   * @type {GetSiteDocumentsResponseData}
   * @memberof GetSiteDocumentsResponse
   */
  data?: GetSiteDocumentsResponseData
}

export function GetSiteDocumentsResponseFromJSON(json: any): GetSiteDocumentsResponse {
  return GetSiteDocumentsResponseFromJSONTyped(json, false)
}

export function GetSiteDocumentsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetSiteDocumentsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetSiteDocumentsResponseDataFromJSON(json['data'])
  }
}

export function GetSiteDocumentsResponseToJSON(value?: GetSiteDocumentsResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetSiteDocumentsResponseDataToJSON(value.data)
  }
}
